import React, { useState } from "react";
import { Box, Typography, Button, Grid, FormControl, FormLabel, TextField, Select, MenuItem, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styled from "styled-components";
import { postData, putData } from "../../BaseUrl";
import Toast from "../../DynamicComponent/Toast";

const StyledTextField = styled(TextField)(() => ({
  "& .MuiOutlinedInput-root": {
    "& fieldset": { borderColor: "#D5D7DA", borderRadius: "10px" },
  },
}));

const labelStyle = { color: "#8F95B2", fontSize: "13px" };

export default function GoogleClassroomForm({ handleClose, initialData }) {
  const isEdit = Boolean(initialData?.id);
  const [form, setForm] = useState({
    term: initialData?.term || "Term 1",
    date: initialData?.startDate ? initialData.startDate.substring(0, 10) : "",
    classroomUrl: initialData?.classroomUrl || "",
    classroomCode: initialData?.classroomCode || "",
    academicYear: initialData?.academicYear || "2025-2026",
  });
  const [toast, setToast] = useState({ open: false, severity: "success", message: "" });

  const handleChange = (e) => setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEdit) {
        await putData(`teacher/classroom/${initialData.id}`, form);
        setToast({ open: true, severity: "success", message: "Classroom updated successfully" });
      } else {
        await postData("teacher/classroom/create", form);
        setToast({ open: true, severity: "success", message: "Classroom created successfully" });
      }
      setTimeout(handleClose, 1200);
    } catch (_) {
      setToast({ open: true, severity: "error", message: isEdit ? "Update failed" : "Failed to create classroom" });
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ p: "24px" }}>
      <Toast open={toast.open} handleClose={() => setToast({ ...toast, open: false })} severity={toast.severity} message={toast.message} />
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>{isEdit ? "Edit Google Classroom" : "Add Google Class Room"}</Typography>
        <IconButton onClick={handleClose}><CloseIcon /></IconButton>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <FormLabel sx={labelStyle}>Term</FormLabel>
            <Select size="small" name="term" value={form.term} onChange={handleChange} sx={{ borderRadius: "10px" }}>
              <MenuItem value="Term 1">Term 1</MenuItem>
              <MenuItem value="Term 2">Term 2</MenuItem>
              <MenuItem value="Term 3">Term 3</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <FormLabel sx={labelStyle}>Date</FormLabel>
            <StyledTextField size="small" name="date" type="date" value={form.date} onChange={handleChange} InputLabelProps={{ shrink: true }} />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <FormLabel sx={labelStyle}>Google Class Room URL</FormLabel>
            <StyledTextField size="small" name="classroomUrl" value={form.classroomUrl} onChange={handleChange} placeholder="https://classroom.google.com/c/..." />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <FormLabel sx={labelStyle}>Class Room Code</FormLabel>
            <StyledTextField size="small" name="classroomCode" value={form.classroomCode} onChange={handleChange} placeholder="e.g. abc123" />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <FormLabel sx={labelStyle}>Academic Year</FormLabel>
            <Select size="small" name="academicYear" value={form.academicYear} onChange={handleChange} sx={{ borderRadius: "10px" }}>
              <MenuItem value="2025-2026">2025-2026</MenuItem>
              <MenuItem value="2026-2027">2026-2027</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 3 }}>
        <Button onClick={handleClose} variant="outlined" sx={{ color: "#4caf50", borderColor: "#4caf50", borderRadius: "10px", textTransform: "none", px: 4 }}>Cancel</Button>
        <Button type="submit" sx={{ backgroundColor: "#1a237e", color: "#fff", borderRadius: "10px", textTransform: "none", px: 4, "&:hover": { backgroundColor: "#283593" } }}>
          {isEdit ? "Update" : "Submitted"}
        </Button>
      </Box>
    </Box>
  );
}
